import HomeIcon from './HomeIcon';
import RequestIcon from './RequestIcon';
import RequestApplyIcon from './RequestApplyIcon';
import RequestPendingIcon from './RequestPendingIcon';
import RequestCompleteIcon from './RequestCompleteIcon';
import ApprovalPendingIcon from './ApprovalPendingIcon';
import ApprovalCompleteIcon from './ApprovalCompleteIcon';
import NoticeIcon from './NoticeIcon';
import DelegationIcon from './DelegationIcon';

export default {
  HomeIcon,
  RequestIcon,
  RequestApplyIcon,
  RequestPendingIcon,
  RequestCompleteIcon,
  ApprovalPendingIcon,
  ApprovalCompleteIcon,
  DelegationIcon,
  NoticeIcon,
};
